import {
  EditOutlined
} from "@ant-design/icons";
import { Card, Checkbox, Dropdown, Menu, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useAsyncFn } from "react-use";
import Search from "../../../../../Layout/search";
import { useAppSelector } from "../../../../../app/hooks";
import SearchComponent from "../../components/searchComponent";
import "../../styles.scss";
import { getAllGroupAction, getDetailCustomerAction, getListCustomerAction } from "./slice";

const CustomerPage = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState<any>({
    data: [],
    count: 0,
    currentPage: 1,
  });
  const [stateDetail, setStateDetail] = useState<any>({
    data: null,
  });
  const [dataDetailState, dataDetailStateFn] = useAsyncFn(async (params: any) => {
    return dispatch(getDetailCustomerAction(params) as any);
  });

  const _onChangePage = async (page: number) => {
    setState({ ...state, currentPage: page });
  };

  const dataReducer = useAppSelector((state) => state.screens.customer);

  useEffect(() => {
    dispatch(getListCustomerAction({}) as any);
    dispatch(getAllGroupAction({}) as any);
  }, [dispatch]);

  useEffect(() => {
    if (dataReducer) {
      var data1 = dataReducer?.data?.map((item: any) => { return ({ ...item }) })
      var res = {
        data: data1,
      }
      setState(res);
    }
    if (dataReducer?.dataDetail) {
      setStateDetail(dataReducer?.dataDetail);
    }
  }, [dataReducer]);

  const onGetDetail = (query: any) => {
    return dataDetailStateFn(query);
  };

  const header: any = [
    {
      title: "STT",
      key: "id",
      dataIndex: "id",
      align: "center",
      render: (_text: string, record: any, index: number) => {
        return <>{index + 1}</>;
      },
    },
    {
      title: "Mã đối tác",
      key: "maDoiTac",
      dataIndex: "maDoiTac",
      align: "center",
    },
    {
      title: "Tên đối tác",
      key: "tenDoiTac",
      dataIndex: "tenDoiTac",
      align: "center",
    },
    {
      title: "Nhóm đối tác",
      key: "nhomDoiTac",
      dataIndex: "nhomDoiTac",
      align: "center",
    },
    {
      title: "Là nhân viên",
      key: "laNhanVien",
      dataIndex: "laNhanVien",
      align: "center",
      render: (_text: string, record: any, index: number) => {
        return <div>
          {record.laNhanVien === "Y" ? <Checkbox checked={true} /> :
            <Checkbox checked={false} />}
        </div>
      },
    },
    {
      title: "Tên ngân hàng",
      key: "tenNganHang",
      dataIndex: "tenNganHang",
      align: "center",
    },
    {
      title: "Người đại diện",
      key: "nguoiDaiDien",
      dataIndex: "nguoiDaiDien",
      align: "center",
    },
    {
      title: "Mô tả",
      key: "moTa",
      dataIndex: "moTa",
      align: "center",
    },
    // {
    //   title: "Thao tác",
    //   key: "action",
    //   align: "right" as "right",
    //   render: (_text: string, record: any, index: number) => {
    //     return (
    //       <Dropdown
    //         key={`dr-${index}`}
    //         overlay={menu(record, index)}
    //         className="cursor-pointer"
    //       >
    //       </Dropdown>
    //     );
    //   },
    // },
  ]

  const menu = (item: any, index: number) => {
    return (
      <Menu key={index}>
          <Menu.Item key={`ite-${index}`} icon={<EditOutlined />}>
            <Link
              key="update"
              to={{ pathname: `/certificate/update/${item.id}` }}
              title="update"
            >
              Chỉnh sửa
            </Link>
          </Menu.Item>
      </Menu>
    );
  };


  const history = useHistory();

  const handleDoubleClick = (id: any) => {
    const url = "/crm/customer-detail/" + id // Thay đổi địa chỉ URL tùy thuộc vào yêu cầu của bạn
    history.push(url);
  };

  return (
    <>
      <Card
        title={<h3 className="text-xl">Danh sách khách hàng</h3>}
        className="rounded-none"
      >
        <Search>
          <SearchComponent />
        </Search>
        <Table
          dataSource={state?.data || []}
          columns={header}
          pagination={{
            defaultPageSize: 10,
            total: state?.count || 0,
            showSizeChanger: false,
            onChange: _onChangePage,
          }}
          rowKey={"id"}
          bordered
          onRow={(record) => {
            return {
              onDoubleClick: () => {
                  handleDoubleClick(record?.maDoiTac);
                  onGetDetail(record?.maDoiTac)
                },
            };
          }}
        />
      </Card>
    </>
  )
}

export default CustomerPage;